var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGlitter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.11975 24.0919C8.15858 24.0919 10.622 26.5554 10.622 29.5942C10.622 26.5554 13.0855 24.0919 16.1243 24.0919C13.0855 24.0919 10.622 21.6284 10.622 18.5896C10.622 21.6284 8.15858 24.0919 5.11975 24.0919Z",
    stroke: "#A7C90D",
    strokeWidth: 2.0625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8755 19.9649C21.9143 19.9649 24.3778 22.4284 24.3778 25.4672C24.3778 22.4284 26.8412 19.9649 29.8801 19.9649C26.8412 19.9649 24.3778 17.5015 24.3778 14.4626C24.3778 17.5015 21.9143 19.9649 18.8755 19.9649V19.9649Z",
    stroke: "#A7C90D",
    strokeWidth: 2.0625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6222 10.3358C13.661 10.3358 16.1245 12.7992 16.1245 15.8381C16.1245 12.7992 18.5879 10.3358 21.6268 10.3358C18.5879 10.3358 16.1245 7.87233 16.1245 4.8335C16.1245 7.87233 13.661 10.3358 10.6222 10.3358Z",
    stroke: "#A7C90D",
    strokeWidth: 2.0625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlitter);
export default __webpack_public_path__ + "static/media/glitter.fb853c89e1169f9ecc4d8d646d4ee8f7.svg";
export { ForwardRef as ReactComponent };